import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSizeClass } from "../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { Platform } from "react-native";

export function useModalInsets() {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const safeArea = useSafeAreaInsets();

  return Platform.OS === "android"
    ? {
        bottom: safeArea.bottom,
        left: safeArea.left,
        right: safeArea.right,
        top: safeArea.top,
      }
    : isCompact
      ? {
          top: 0,
          bottom: safeArea.bottom,
          left: safeArea.left,
          right: safeArea.right,
        }
      : { top: 0, bottom: 0, left: 0, right: 0 };
}
